// Alignment enums
export enum HorizontalAlign {
  CENTER = "center",
  LEFT = "left",
  RIGHT = "right",
}
